import { CSSProperties } from "react";

interface PaymentButtonProps {
    styles?: CSSProperties;
    onClick?: () => void | Promise<void>;
    title: string;
    icon?: string;
}

const BuilderPaymentButton = ({ styles, title, onClick }: PaymentButtonProps) => {
    return (
        <button className="payment-button" style={styles} onClick={onClick}>
            {title}
        </button>
    );
};

export default BuilderPaymentButton;
